// src/components/home/GameInfo.tsx
import React from 'react';

/** The four career stages the progression artwork shows, left to right. */
const STAGES = [
    { no: '01', label: 'Patrull' },
    { no: '02', label: 'K9' },
    { no: '03', label: 'Kiirreageerija' },
    { no: '04', label: 'Juhtkond' }
];

/**
 * The situation briefing.
 *
 * The artwork and the narrative sit side by side, with the career stages labelling
 * the figures directly beneath them. This absorbed what used to be a separate
 * "Sinu tee tippu" section — the artwork says the same thing, and one section
 * carrying both reads better than two making the same point.
 */
export const GameInfo: React.FC = () => (
    <section className="lp-section" id="lugu">
        <div className="lp-shell">
            <div className="lp-section__head">
                <p className="lp-eyebrow">
                    <span className="lp-eyebrow__dot" />
                    Olukorra ülevaade
                </p>
                <h2 className="lp-section__title">Eesti vajab sind</h2>
            </div>

            <div className="lp-briefing">
                <figure className="lp-briefing__figure">
                    <div className="lp-briefing__art">
                        <img
                            src="/images/through-ranks.png"
                            alt="Politseiniku areng: patrullist K9 ja kiirreageerijani ning juhtkonnani"
                            className="lp-briefing__img"
                            width={1280}
                            height={720}
                            loading="lazy"
                            decoding="async"
                        />
                    </div>
                    <figcaption className="lp-stages">
                        {STAGES.map((stage) => (
                            <span className="lp-stage" key={stage.no}>
                                <span className="lp-stage__no">{stage.no}</span>
                                <span className="lp-stage__label">{stage.label}</span>
                            </span>
                        ))}
                    </figcaption>
                </figure>

                <div className="lp-briefing__body">
                    <p>
                        Kuritegevus on tõusuteel. Narkodiilerid, relvakaubitsejad ja
                        organiseeritud grupeeringud on end Eesti linnadesse sisse seadnud.
                        Ainult sina ja su kolleegid saate korra taastada.
                    </p>
                    <p>
                        Alustad <strong>politseikoolist</strong> ja töötad end vahetus haaval
                        üles. Iga läbitud koolitus, iga treening ja iga lahendatud väljakutse
                        viib sind auastmelt järgmisele.
                    </p>
                    <div className="lp-note">
                        <p className="lp-note__text">
                            Kümme auastet. Alusta nulliga, lõpeta kolonelleitnandina.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
);
